// src/providers/AppThemeProvider.tsx
import { ThemeProvider, CssBaseline, useMediaQuery } from '@mui/material';
import { useMemo } from 'react';
import { createAppTheme } from '../shared/theme/muiTheme';

export function AppThemeProvider(
    {
        children,
        darkMode,
        primaryColor,
        accentColor,
        companyName,
    }
                                 ) {
    const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
    const shouldUseDarkMode = darkMode ?? prefersDarkMode;
    const theme = useMemo(
        () =>
            createAppTheme(
                primaryColor,
                accentColor,
                companyName,
                shouldUseDarkMode
            ),
        [primaryColor, accentColor, companyName, shouldUseDarkMode],
    );

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            {children}
        </ThemeProvider>
    );
}
